import React from 'react';
import './ReviewSection.css';

const reviews = [
  {
    id: 1,
    tag: 'Decor & balloons',
    text:
      'Thanks for the awesome decorations and balloons! The place looked great and really brought the party vibe together. Everyone loved it—appreciate your work! 🎈 🙌',
    time: '9:51 am',
  },
  {
    id: 2,
    tag: 'Magic & tattoo',
    text:
      'Thanks Bubbles & Balloons for the tattoo and magic show—it was so amazing, all were so happy and everyone was asking for the magic show person’s number. He did it so nicely, made children laugh and played games as well. 👏 👏',
    time: '8:11 am',
  },
  {
    id: 3,
    tag: 'Games & décor',
    text: 'Thanks Bubbles & Balloons Both the party games and deco were nice.',
    time: '9:10 am',
  },
  {
    id: 4,
    tag: 'Magic show',
    text:
      'Thank you Bubbles & Balloons! The magic show was awesome. We all enjoyed it. Convey our message to the magician—he was a very nice entertainer. 😊',
    time: '11:31 pm',
  },
];

const ReviewSection = () => {
  return (
    <section id="reviews" className="review-section" aria-labelledby="reviews-heading">
      <div className="review-bg" aria-hidden="true" />
      <div className="review-container">
        <header className="review-header">
          <h2 id="reviews-heading" className="review-title">
            <span className="review-title-part">What our</span>{' '}
            <span className="review-title-highlight">clients say</span>
          </h2>
          <p className="review-subtitle">
            Real messages from celebrations we’ve styled—decor, games, and entertainment your guests remember.
          </p>
        </header>

        <ul className="review-grid">
          {reviews.map((item) => (
            <li key={item.id} className="review-card-wrap">
              <article className="review-bubble" aria-label={`Review: ${item.tag}`}>
                <div className="review-bubble-tail" aria-hidden="true" />
                <span className="review-tag">{item.tag}</span>
                <p className="review-text">{item.text}</p>
                <div className="review-meta">
                  <span className="review-stars" aria-hidden="true">
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                  </span>
                  <span className="review-time">{item.time}</span>
                </div>
              </article>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ReviewSection;
